import { Button, Form, SidebarModal } from '@domain-group/suit-theme'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import useSystem, { useSystemForm } from '@hooks/useSystem'

import type { ActionResult } from '@redux/modules/types'

import type { SystemModel } from '@models/types'

interface ModalCallbacks {
  closeModal: () => void,
  createSystem: (payload: HandleCallbackActionParams) => Promise<ActionResult<SystemModel>>,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  modalKey?: string,
  showModal: boolean,
}

const CreateSystemModal = (props: ModalProps) => {
  const { callbacks, modalKey = 'CreateSystemModal', showModal } = props
  const { closeModal, createSystem } = callbacks

  const systemPayload = useSystem()
  const systemFormPayload = useSystemForm({}, { validateOn: 'change' })

  const {
    callbacks: {
      createSystem: createFn,
    },
    creating,
  } = systemPayload

  const {
    entityState,
    entityState: {
      email,
      title,
      url,
    },
    errors,
    handlers,
    saveEnabled,
  } = systemFormPayload

  const createSystemPayload = {
    callbacks: {
      action: createFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    shouldRedirect: true,
    toastText: 'System Created',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Create" titleSecondLine="System" />

      <SidebarModal.Content>
        <Form>
          <Form.Field label="* Title" errorMessage={errors.title}>
            <input type="text" name="title" value={title} {...handlers} />
          </Form.Field>

          <Form.Field label="* Email" errorMessage={errors.email} marginTop="large">
            <input type="email" name="email" value={email} {...handlers} />
          </Form.Field>

          <Form.Field label="* URL" errorMessage={errors.url} marginTop="large">
            <input type="text" name="url" value={url} {...handlers} />
          </Form.Field>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={creating}
          onClick={() => createSystem(createSystemPayload)}
          size="large"
        >
          {saveEnabled ? 'Create System' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <CreateSystemModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
